import { InvestmentReqRes } from "src/app/dashboard/models/investment.model";
import { InvestmentStatus } from "src/app/shared/enums/InvestmentStatus.enum";
import { PaymentStatus } from "src/app/shared/enums/PaymentStatus.enum";
import { SignPlatform } from "src/app/shared/enums/SignPlatform.enum";
export interface InvestmentStatusModel {
  key: string;
  title: string;
  class: string;
}

export const ALL_INVESTMENT_STATUSES: InvestmentStatusModel[] = [
    { key: 'Potential', title: 'Potential', class: 'status-Potential' },
    { key: 'SoftCircled', title: 'Soft Circled', class: 'status-SoftCircled' },
    { key: 'AwaitingSignatureGP', title: 'Awaiting GP Signature', class: 'status-AwaitingSignatureGP' },
    { key: 'AwaitingSignatureInvestor', title: 'Awaiting Investor Signature', class: 'status-AwaitingSignatureInvestor' },
    { key: 'Canceled', title: 'Canceled', class: 'status-Canceled' },
    { key: 'Called', title: 'Called', class: 'status-Called' },
    { key: 'Transferred', title: 'Transferred', class: 'status-Transferred' },
    { key: 'Signed', title: 'Signed', class: 'status-Signed' },
    { key: 'Invested', title: 'Invested', class: 'status-Invested' },
    { key: 'Declined', title: 'Declined', class: 'status-Declined' },
  ];

export function getStatus(investment: InvestmentReqRes): InvestmentStatusModel {
    const status: InvestmentStatus = investment.status;
    
    if( status === InvestmentStatus.Potential) {
      return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Potential');
    }

    if( status === InvestmentStatus.SoftCircled) {
        if( !investment.isAgreementSigned && !investment.agreementMetaFileLinkId && investment.agreementSignPlatform === SignPlatform.HelloSign) {
            return ALL_INVESTMENT_STATUSES.find(s => s.key === 'AwaitingSignatureInvestor');
        }

        return ALL_INVESTMENT_STATUSES.find(s => s.key === 'SoftCircled');
    }

    if( status === InvestmentStatus.Declined) {
      return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Declined');
    }

    if( status === InvestmentStatus.Invested) {
      return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Invested');
    }

    if( status === InvestmentStatus.Signed) {
        if( investment.isAgreementSigned && !investment.agreementMetaFileLinkId && investment.agreementSignPlatform === SignPlatform.HelloSign) {
            return ALL_INVESTMENT_STATUSES.find(s => s.key === 'AwaitingSignatureGP');
        }
        
        if(!!investment.paymentRequestSendDate) {
            if (investment.paymentStatus === PaymentStatus.Canceled) {
            return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Canceled');
            } else if (!investment.transferDate) {
            return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Called');
            
            } else if (!!investment.transferDate) {
            return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Transferred');
            } 
        }

      return ALL_INVESTMENT_STATUSES.find(s => s.key === 'Signed');
    }

    return {class: '', title: '', key: undefined};
  }